import { Trash2 } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const DeleteIcon = createLucideIcon(Trash2);
